import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Tracks when a homescreen "Today" page section (e.g. Journey Videos, Conversation Starters)
// scrolls into view, and when it's clicked. The view fires at most once per page load;
// clicks are not deduped, since repeat interactions within a section are meaningful.
export default class extends Controller {
  static values = {
    viewEvent: String,
    clickEvent: String,
    referrer: String,
    resourceId: Number,
    targetType: String
  }

  connect() {
    this.hasLoggedView = false
    this.observer = new IntersectionObserver(this.#handleIntersect.bind(this), { threshold: 0.5 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  click() {
    this.#log(this.clickEventValue)
  }

  #handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.hasLoggedView) {
        this.hasLoggedView = true
        this.#log(this.viewEventValue)
      }
    })
  }

  async #log(event) {
    if (!event) return

    try {
      await post("/user_activities/activity", {
        body: JSON.stringify({
          event,
          resource_id: this.hasResourceIdValue ? this.resourceIdValue : undefined,
          target_type: this.hasTargetTypeValue ? this.targetTypeValue : undefined,
          referrer: this.hasReferrerValue ? this.referrerValue : undefined
        })
      })
    } catch (error) {
      console.error(`Failed to log ${event}:`, error)
    }
  }
}
